export default __webpack_public_path__ + "static/media/competitions.71e38991.gif";